import React from "react";
import './about_me.css';
import photo from './photo.png';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
const AboutMe = () =>{

useEffect(()=>{
 Aos.init({
   duration: 3000,
    
  });
},[]);
    return(
        <div className="aboutme"  data-aos= 'slide-up' >
          <h3>About Me</h3>
          <div className="aboutme__details">
             <img src={photo} alt= "my_photo" />
             <div className="about__description">
             <p>Hi, I'm Kenneth Bett, a passionate web developer from Kenya. I've been building stuff on the web since when I was in 6th standard, I've made countless side projects and I also posses magical powers of using React and Node js to build poweful web applications.<br /><br />
                       
             I also love doing open source development and mentoring upcoming developers, I actively try to mentor junior developers which gives me a wonderful feeling of achievement and joy which I cannot explain in words.</p>
             </div>
              
          </div>
          <div className="aboutme__clip">

          </div>
        </div>
    );
}

export default React.memo(AboutMe);